import { useQuery } from '@tanstack/react-query';

import { webFormsApi } from '../axios';
import { DocumentValidationResponse } from '../types';

export function useFormAnswerInfoQuery(formAnswerId: string, token?: string) {
  return useQuery({
    queryKey: ['formAnswerInfo', formAnswerId],
    queryFn: () => webFormsApi.getFormAnswerWithTaskData(formAnswerId, token),
    enabled: !!formAnswerId,
  });
}

export function useFormAnswerAnswersListQuery(formAnswerId: string, token?: string, pdfMode = false) {
  return useQuery({
    queryKey: ['formAnswerAnswersList', formAnswerId, pdfMode],
    queryFn: () =>
      token
        ? webFormsApi.getPublicFormAnswer(formAnswerId, token, pdfMode)
        : webFormsApi.getFormAnswer(formAnswerId, pdfMode),
    enabled: !!formAnswerId,
  });
}

export function useDocumentValidationQuery(md5Name: string | undefined) {
  return useQuery<DocumentValidationResponse>({
    queryKey: ['documentValidation', md5Name],
    queryFn: () => webFormsApi.getDocumentValidation(md5Name ?? ''),
    enabled: !!md5Name,
  });
}
